export default "__VITE_ASSET__DHuFs3kh__"